import React, { useEffect } from "react";
import StaticLayout from "../../layout/StaticPageLayout2";
import useCountdown from "../../components/useCountdown";
import { useNavigate } from "react-router-dom";
import { routeObj } from "../../constants/routes";

export default function FailedTransaction() {
  const router = useNavigate();

  const { seconds, hasEnded, resetCountdown } = useCountdown(0);
  useEffect(() => {
    const date = new Date();
    const newDate = date.setSeconds(date.getSeconds() + 9);
    resetCountdown(newDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (hasEnded) {
      router(routeObj.landing);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasEnded]);
  return (
    <div className=" flex justify-center items-center h-screen flex-col gap-2 ">
      <img src="/img/cancel.svg" alt="" />
      <p className="text-xs md:text-lg ">Transaction Failed</p>
      <p className="text-xs md:text-lg ">
        You will be redirected in {seconds}s....
      </p>
    </div>
  );
}
